import { Flex, FlexProps, Icon, Image, Switch, Text } from "@chakra-ui/react";
import { Button } from "barte-design-system";
import { ReactNode, useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
interface ContainerProps extends FlexProps {
  setContainerValue?: (prop: boolean) => void;
  containerValue?: boolean;
  active?: boolean;
  startsOpen?: boolean;
  title: string;
  hasPadding?: boolean;
  children: ReactNode;
  isOk?: boolean;
  type?: "check" | "retract";
  button?: boolean;
  buttonTitle?: string;
  buttonAction?: () => void;
  buttonDisabled?: boolean;
  borderColor?: string;
  backgroundColor?: string;
  borderRadius?: string;
  border?: string;
  padding?: string;
  paddingTitle?: string;
}
export function NewContainer({ padding, paddingTitle, borderColor, backgroundColor, borderRadius, border, startsOpen, isOk, containerValue, type, setContainerValue, active, title, children, hasPadding, button, buttonTitle, buttonAction, buttonDisabled, ...rest }: ContainerProps) {
  const [containerState, setContainerState] = useState(true);
  return (
    <Flex
      p={hasPadding ? "1.5rem" : ""}
      gap="1rem"
      flexDirection="column"
      maxW="740px"
      minW="540px"
      {...rest}
    >
      {type === "check" && (
        <>
          <Flex
            w="100%"
            gap="10px"
            alignItems={button ? "center" : ""}
          >

            {title && (
              <Text
                fontSize="1rem"
                color="black"
                fontWeight="600"
                p={paddingTitle}
              >
                {title}
              </Text>
            )}

          </Flex>
          <Flex
            flexDir="column"
            display={containerState ? "flex" : "none"}
            gap="1.5rem"
            borderRadius={borderRadius}
            border={border}
            backgroundColor={backgroundColor}
            p={padding}
            w="100%"
          >
            {active && (
              <Flex align="center" justify="space-between">
                <Text fontSize="16px" color="black" fontWeight="600">Ativar {title.toLowerCase()}</Text>
                <Switch
                  defaultChecked={containerValue}
                  colorScheme="cyan"
                  onChange={(e) => setContainerValue(e.target.checked)}
                />
              </Flex>
            )}
            {children}
          </Flex>
        </>
      )}
      {type === "retract" && (
        <Flex
          w="100%"
          flexDirection="column"
          justifyContent="start"
          gap="12px"
          borderRadius={borderRadius}
          border={border}
          backgroundColor={backgroundColor}
          p={padding}
        >
          <Flex
            w="100%"
            justify="space-between"
            gap="10px"
            cursor="pointer"
            onClick={() => setContainerState(!containerState)}
          >
            {title && (
              <Text
                fontSize="1rem"
                color="black"
                fontWeight="600"
              >
                {title}
              </Text>
            )}
            <Icon fontSize="1.6rem" as={containerState ? MdKeyboardArrowUp : MdKeyboardArrowDown} />

          </Flex>
          <Flex
            flexDir="column"
            display={containerState ? "flex" : "none"}
            // gap="1.5rem"
          // marginLeft="auto"
          // w="50%"
          >
            {active && (
              <Flex align="center"


              >
                <Text fontSize="16px" color="black" fontWeight="600">Ativar {title.toLowerCase()}</Text>
                <Switch
                  defaultChecked={containerValue}
                  onChange={(e) => setContainerValue(e.target.checked)}
                />
              </Flex>
            )}
            {children}
          </Flex>
        </Flex>
      )}
      {button && (
        <Button
          type="button"
          onClick={buttonAction}
          variant="outline"
          style={{ maxWidth: "360px", marginLeft: "auto" }}
          disabled={buttonDisabled}
        >
          {buttonTitle}
        </Button>
      )}
    </Flex>
  )
}